import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import httpMethod from 'services/update2025/httpMethod';

import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";

import { ForeignerRegisterContext } from "components/foreigner-register/ForeignerRegisterContext";
import { findCountryById } from "services/CountryService";
import { Button } from "primereact/button";

export const ForeignerRegisterEditor = () => {
    const toast = useRef(null);
    const { t, i18n } = useTranslation(["foreigner-register", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const foreignerRegisterContext = useContext(ForeignerRegisterContext);
    const { register, setRegister, registerDialog, setRegisterDialog } = foreignerRegisterContext;

    const [nationality, setNationality] = useState(null);

    useEffect(() => {
        if (register) {
            let nationalityPromise = findCountryById(headers, register?.nationality);

            Promise.all([nationalityPromise]).then((values) => {
                const nationalName = values[0]?.data?.name;

                setNationality(`${nationalName}`);
            });
        }
    }, [register]);

    const genders = [
        { label: t("male", { ns: "common" }), value: "1" },
        { label: t("female", { ns: "common" }), value: "0" },
    ];

    const states = [
        { label: t("registering"), value: "REGISTERING" },
        { label: t("otp.verified"), value: "OTP_VERIFIED" },
        { label: t("expired"), value: "EXPIRED" },
        { label: t("completed"), value: "COMPLETED" },
    ];

    const hideDialog = () => {
        setRegisterDialog(false);
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog visible={registerDialog} style={{ width: "70%" }} header={t("register.titleDetail")} modal className="p-fluid text-center" onHide={hideDialog}>
                <div className="formgrid">
                    <div className="grid text-left">
                        <div className="col-12">
                            <div className="grid">
                                {/* số hộ chiếu */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="passportNo">{t("passportNo")}</label>
                                    <InputText id="passportNo" value={register?.passportNo} readOnly />
                                </div>

                                {/* Số điện thoại */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="phoneNumber">{t("phoneNumber")}</label>
                                    <InputText id="phoneNumber" value={register?.phoneNumber} readOnly />
                                </div>

                                {/* email */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="email">{t("email")}</label>
                                    <InputText id="email" value={register?.email} readOnly />
                                </div>

                                {/* quốc tich */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="nationality">{t("nationality")}</label>
                                    <InputText id="nationality" value={nationality} readOnly />
                                </div>
                            </div>
                            <div className="grid">
                                {/* họ và tên */}
                                <div className="field col-12 md:col-6">
                                    <label htmlFor="fullName">{t("fullName")}</label>
                                    <InputText id="fullName" value={register?.fullName} readOnly />
                                </div>

                                {/* ngày sinh */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="birthdate">{t("birthdate")}</label>
                                    <InputText id="birthdate" value={register?.birthdate} readOnly />
                                </div>
                                {/* giới tính */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="gender">{t("gender")}</label>
                                    <InputText id="gender" value={genders.find((g) => g.value === `${register?.gender}`)?.label} readOnly />
                                </div>
                            </div>
                            <div className="grid">
                                {/* ngày hết hạn */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="expiredDate">{t("expiredDate")}</label>
                                    <InputText id="expiredDate" value={register?.expiredDate} readOnly />
                                </div>

                                {/* trạng thái */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="state">{t("state")}</label>
                                    <InputText id="state" value={states.find((g) => g.value === register?.state)?.label} readOnly />
                                </div>

                                {/* ngày tạo */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="createdDate">{t("createdDate", { ns: "common" })}</label>
                                    <InputText id="createdDate" value={register?.createdDate} readOnly />
                                </div>

                                {/* ngày sửa */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="modifiedDate">{t("modifiedDate", { ns: "common" })}</label>
                                    <InputText id="modifiedDate" value={register?.modifiedDate} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        {/* close */}
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            className="mr-2 p-button-danger"
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
